// extracted by mini-css-extract-plugin
module.exports = {"boxOnlyDetails":"BoxOnlyDetails_boxOnlyDetails__2g7O7"};